package com.vizio.redwolf.auth.model

data class SendVerificationEmailRequestInfo(val accessToken: String)